export default __webpack_public_path__ + "i18n/translations/translation-sv.c4156f51.json";